export var parseCSV = function (strData, strDelimiter) {
    strDelimiter = strDelimiter || ",";
    var objPattern = new RegExp("(\\" +
        strDelimiter +
        "|\\r?\\n|\\r|^)" +
        '(?:"([^"]*(?:""[^"]*)*)"|' +
        '([^"\\' +
        strDelimiter +
        "\\r\\n]*))", "gi");
    var arrData = [[]];
    var arrMatches = null;
    while ((arrMatches = objPattern.exec(strData))) {
        var strMatchedDelimiter = arrMatches[1];
        if (strMatchedDelimiter.length && strMatchedDelimiter != strDelimiter) {
            arrData.push([]);
        }
        var strMatchedValue = "";
        if (arrMatches[2]) {
            strMatchedValue = arrMatches[2].replace(new RegExp('""', "g"), '"');
        }
        else {
            strMatchedValue = arrMatches[3];
        }
        arrData[arrData.length - 1].push(strMatchedValue);
    }
    var lastRow = arrData[arrData.length - 1];
    var clearLastRow = lastRow.length === 1 && lastRow[0] === "";
    if (clearLastRow) {
        arrData.splice(-1);
    }
    return arrData;
};
//# sourceMappingURL=parseCSV.js.map